module.exports = __webpack_public_path__ + "img/qr-code-scan.d7df3ede.svg";